import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store";
import { setFeatures, clearPurchaseSuccess } from "./features.slice";
import {
  selectFeatures,
  selectPurchaseSuccess,
} from "./features.selector";

/**
 * Listen to feature changes (storage + purchase)
 */
export function useFeaturesListener() {
  const dispatch = useAppDispatch();
  const purchaseSuccess = useAppSelector(selectPurchaseSuccess);

  // סנכרון בין טאבים
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === "features" && e.newValue) {
        dispatch(setFeatures(JSON.parse(e.newValue)));
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [dispatch]);

  // אחרי רכישה
  useEffect(() => {
    if (!purchaseSuccess) return;

    const data = JSON.parse(localStorage.getItem("features") || "[]");
    dispatch(setFeatures(data));
    dispatch(clearPurchaseSuccess());
  }, [purchaseSuccess, dispatch]);
}


/**
 * Manually refresh features
 */
export function useRefreshAllFeatures() {
  const dispatch = useAppDispatch();

  return () => {
    const updatedFeatures = JSON.parse(
      localStorage.getItem("features") || "[]"
    );
    dispatch(setFeatures(updatedFeatures));
  };
}

/**
 * Get current features
 */
export function useFeature() {
  return useAppSelector(selectFeatures);
}

/**
 * Check purchase success flag
 */
export function usePurchaseSuccess() {
  return useAppSelector(selectPurchaseSuccess);
}
